import React, { FC } from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { blueGrey } from "@mui/material/colors";
import dealerRoles from "../../util/dealerAccounts";

const StyledCustomerInfoDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  width: "100%",
  flexWrap: "wrap",
});

const StyledCustomerInputDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingBottom: 20,
});

const StyledLabel = styled(Typography)({
  width: 120,
  flexShrink: 0,
  textAlign: "right",
  marginRight: 5,
});

const StyledInput = styled("input")(({ theme }) => ({
  backgroundColor: blueGrey[50],
  border: "1px solid grey",
  borderRadius: "4px",
  height: "30px",
  width: 300,
  [theme.breakpoints.down("sm")]: {
    width: 150,
    marginLeft: 5,
  },
}));

interface CustomerInfoProps {
  signInRole: string;
  handleAllChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
}

const CustomerInfo: FC<CustomerInfoProps> = ({
  signInRole,
  handleAllChange,
  customerName,
  customerEmail,
  customerPhone,
}) => {
  return (
    <StyledCustomerInfoDiv>
      <StyledCustomerInputDiv>
        <StyledLabel variant="body2">
          Customer Name:
          {dealerRoles.includes(signInRole) && (
            <span style={{ color: "red", fontSize: 22 }}>* </span>
          )}
        </StyledLabel>
        <StyledInput
          maxLength={40}
          onChange={handleAllChange}
          name="customerName"
          value={customerName}
          placeholder="Customer Name"
        />
      </StyledCustomerInputDiv>

      <StyledCustomerInputDiv>
        <StyledLabel  variant="body2">
          Email:{" "}
        </StyledLabel>
        <StyledInput
          maxLength={40}
          onChange={handleAllChange}
          name="customerEmail"
          value={customerEmail}
          placeholder="Email"
        />
      </StyledCustomerInputDiv>

      <StyledCustomerInputDiv style={{ paddingBottom: 0 }}>
        <StyledLabel variant="body2">
          Phone:{" "}
        </StyledLabel>
        <StyledInput
          maxLength={20}
          onChange={handleAllChange}
          name="customerPhone"
          value={customerPhone}
          placeholder="Phone"
        />
      </StyledCustomerInputDiv>
    </StyledCustomerInfoDiv>
  );
};

export default CustomerInfo;
